import React, { useEffect, useState, useMemo, memo } from 'react';
import { useDispatch, useSelector } from "react-redux";
import moment from 'moment-timezone';
import { Row, Col, Card, Button, Modal } from 'react-bootstrap';
import RegionMap from '../Common/RegionMap';
import { getEGWorkedAcres, updateFieldWorkStatus } from '../../../actions/dashboard';
import { formatNumber, Unit } from '../../../helpers/unit';
import { getDateRangeInfo } from '../../../actions/analyze';
import { /* WORK_TYPE_LIST, */ WORK_TYPE_COLOURS, COMPLETED_WORK_STATUS, HARVESTING_WORK_TYPE_ID, ACTIVE_WORK_STATUS } from '../../../constants';
import '../../../../assets/scss/fieldmap.scss';
import { getDateRange } from '../../../helpers/common';
import { toDisplayDateTimeString2 } from '../../../helpers/moment-ex';

const CardBody = memo(({ shapeRefId, showDropdown, isCompleted, cardMapId, setCardMapId }) => {
  // const { shapeRefId, showDropdown, isCompleted } = props;
  const dispatch = useDispatch();
  const { egWorkedById, selectedWorkTypeIds, fieldListById: { payload: fieldListById }, egListById: { payload: egListById, isRequesting: isRequestingEg },
    workedAcresById: { isRequesting: isRequestingWorkInfo }, fieldHistory: { payload: fieldHistory }, fieldLoads: { payload: fieldLoads } } = useSelector((state) => state.dashboard.field);
  const farmId = useSelector((state) => state.dashboard.farmId);
  const searchParams = useSelector((state) => state.analyze.searchParams);
  const harvestSummary = useSelector((state) => state.dashboard.harvestSummary);
  const isRequestingHarvestSummary = useSelector((state) => state.dashboard.harvestSummary.isRequesting);
  const tareLoadHistory = useSelector((state) => state.dashboard.tareLoadHistory);
  const { weightShortName } = useSelector(state => state.user.settings);

  const { plannedTodate, rangeId, range, customRange, custom } = searchParams;
  const planPlannedToDate = (farmId && plannedTodate && plannedTodate[farmId]) ? plannedTodate[farmId] : null;
  const isRequestingPlanPlannedToDate = planPlannedToDate ? planPlannedToDate.isRequesting : false;
  const { from, to } = custom;

  const egWorkDetails = [];
  for (const id in egWorkedById) {
    if ((id.split("_")[0] === shapeRefId) && selectedWorkTypeIds.indexOf(parseInt(id.split("_")[1])) >= 0)
      egWorkDetails.push(egWorkedById[id]);
  }

  const tareLoadHistoryList = (tareLoadHistory && tareLoadHistory.data && tareLoadHistory.data.length > 0) ? tareLoadHistory.data : [];

  // const [selectedId, setSelectedId] = useState(fieldListById[shapeRefId].regionDetails.geo_region_uuid);
  const [workedPoints, setWorkedPoints] = useState([]);
  const [selectedEG, setSelectedEG] = useState();
  const [harvestSummaryList, setHarvestSummaryList] = useState(null);
  const [currentFieldName, setCurrentFieldName] = useState(null);
  const [complete, setComplete] = useState(false);
  const [fieldWorkStatus, setFieldWorkStatus] = useState({
    workstatus: null,
    farmUuid: null,
    workTypeId: null,
    geoRegionShapeUuid: null,
    geoShapeUuid: null
  })

  const workDetails = egWorkDetails && egWorkDetails.length > 0 ? egWorkDetails[0].payload : [];
  let harvestList = harvestSummaryList && harvestSummaryList.hasOwnProperty(fieldListById[shapeRefId].regionDetails.geo_region_uuid) ? harvestSummaryList[fieldListById[shapeRefId].regionDetails.geo_region_uuid] : null;
  const unit = useMemo(() => Unit.getInstance(), []);

  useEffect(() => {
    if (!isRequestingWorkInfo && (!cardMapId.includes(shapeRefId))) {
      setCardMapId((prev) => [...prev, shapeRefId])
      const cb = (dateInfo) => {
        const workTypeIds = selectedWorkTypeIds;
        const hasWorkTypeIds = egWorkDetails.map(item => item.workTypeId);
        const newWorkTypeIds = workTypeIds.filter(id => hasWorkTypeIds.indexOf(id) < 0);

        if (newWorkTypeIds.length > 0) {
          const params = {
            farmId,
            shapeGroupId: fieldListById[shapeRefId].regionDetails.geo_region_uuid,
            shapeRefId,
            workTypeIds: newWorkTypeIds,
            ...dateInfo
          };
          dispatch(getEGWorkedAcres(params));
        }
      };

      dispatch(getDateRangeInfo({ farmId }, cb));
    }
  }, [isRequestingWorkInfo, rangeId, selectedWorkTypeIds, isRequestingPlanPlannedToDate, cardMapId]);

  const { dateRange, dateRangeType } = useMemo(() => {
    const { name } = getDateRange({ range, custom: { from, to }, customRange });
    const formateDate = date => {
      const tzDate = moment(date);
      const currentTzDate = moment();
      const isCurrentYear = (tzDate.year() === currentTzDate.year());

      return toDisplayDateTimeString2(tzDate, isCurrentYear);
    };
    const isSameDateRange = moment(formateDate(from)).isSame(formateDate(to));
    const dateRange = (name === "Absolute") ? `${formateDate(from)} ${!isSameDateRange ? `- ${formateDate(to)}` : ""}` : name;
    return { dateRange, dateRangeType: name };
  }, [from, to, range, customRange]);

  const getRangeLoads = (format = true) => {
    let rangeLoadCount = 0;
    let rangeLoadCapacity = 0;
    let rangeLoadGrossCapacity = 0;
    let rangeTareLoadCapacity = 0;
    const loads = fieldHistory.filter((e) => moment(e.loadDate).isBetween(moment.utc(custom.from).startOf('day').format(), moment.utc(custom.to).endOf('day').format()));
    if (loads && loads.length > 0) {
      const id = fieldListById[shapeRefId].geo_shape_uuid;
      const fieldLoads = loads.filter((e) => e.fieldGeoShapeId === id);

      rangeLoadCapacity = fieldLoads.reduce((capacity, item) => capacity + item.loadCapacity, 0);
      rangeLoadCapacity = format ? formatNumber(unit.toRoundOfWeight(rangeLoadCapacity, false)) : rangeLoadCapacity;
      rangeLoadCount = fieldLoads.length;

      rangeLoadGrossCapacity = fieldLoads.reduce((capacity, item) => capacity + item.grossWeight, 0);
      rangeLoadGrossCapacity = format ? formatNumber(unit.toRoundOfWeight(rangeLoadGrossCapacity, false)) : rangeLoadGrossCapacity;

      rangeTareLoadCapacity = fieldLoads.reduce((capacity, item) => capacity + item.tareWeight, 0);
      rangeTareLoadCapacity = format ? formatNumber(unit.toRoundOfWeight(rangeTareLoadCapacity, false)) : rangeTareLoadCapacity;

    }
    return { rangeLoadCount, rangeLoadCapacity, rangeLoadGrossCapacity, rangeTareLoadCapacity };
  }

  const getRangeTareLoad = () => {
    let tareCapacity = 0;
    let tareCount = 0;
    let rangeTareCapacity = 0;
    let rangeTareCount = 0;
    const shapeId = fieldListById[shapeRefId].geo_shape_uuid;
    const tareLoads = tareLoadHistoryList.filter((e) => e.field_geo_shape_uuid === shapeId);
    if (tareLoads && tareLoads.length > 0) {
      tareCapacity = tareLoads.reduce((capacity, item) => capacity + item.load_capacity, 0);
      tareCount = tareLoads.length;
      const rangeLoads = tareLoads.filter((e) => moment(e.load_date).isBetween(moment.utc(custom.from).startOf('day').format(), moment.utc(custom.to).endOf('day').format()));
      rangeTareCapacity = rangeLoads.reduce((capacity, item) => capacity + item.load_capacity, 0);
      rangeTareCount = rangeLoads.length;
    }
    return { tareCapacity, tareCount, rangeTareCapacity, rangeTareCount };
  }

  const handleFieldWorkStatus = () => {
    const params = {
      farm_uuid: farmId,
      work_status: [{
        geo_shape_uuid: fieldWorkStatus.geoShapeUuid,
        geo_region_shape_uuid: fieldWorkStatus.geoRegionShapeUuid,
        work_status: fieldWorkStatus.workstatus,
        work_type_id: fieldWorkStatus.workTypeId,
      }]
    };
    dispatch(updateFieldWorkStatus(params));
  };

  const updateStatus = (isCompleted) => {
    setComplete(!complete);
    setCurrentFieldName(fieldListById[shapeRefId].geo_shape_name);
    setFieldWorkStatus({
      ...fieldWorkStatus, workstatus: isCompleted ? COMPLETED_WORK_STATUS : ACTIVE_WORK_STATUS,
      farmUuid: farmId,
      workTypeId: HARVESTING_WORK_TYPE_ID,
      geoRegionShapeUuid: fieldListById[shapeRefId].geo_shape_object_uuid,
      geoShapeUuid: fieldListById[shapeRefId].geo_shape_uuid
    });
  };

  useEffect(() => {
    if (workDetails.length === 0) return;

    let worked = [];
    let workedLatLng = [];

    for (const item of workDetails) {
      if (selectedEG && selectedEG === item.equipment_group_uuid) {
        worked = [];
        const data = item.grid.worked;
        worked.push(data);
        break;
      } else {
        const data = item.grid.worked;
        worked.push(data);
      }
    }

    for (const item of worked) {
      item.forEach(e => {
        e && e.coordinates.forEach(points => {
          const data = points.map(co => { return { lat: co[1], lng: co[0] }; });

          workedLatLng.push(...data);
        });
      });
    }

    setWorkedPoints(workedLatLng);
  }, [workDetails, selectedEG]);

  useEffect(() => {
    if (!isRequestingHarvestSummary) {
      const payload = harvestSummary.payload;
      setHarvestSummaryList({ ...payload });
    }
  }, [isRequestingHarvestSummary]);

  const newWorkedPoints = useMemo(() => {
    let workedLatLng = [];
    if (showDropdown && !isRequestingHarvestSummary) {
      const acres = (harvestList && harvestList.acres && harvestList.acres.length > 0) ? harvestList.acres : [];
      if (acres.length > 0 && acres[0]) {
        const { /* type, */ coordinates } = acres[0]
        let coordinatesData = coordinates || [];
        coordinatesData = [];
        //(type && type === "Polygon") ? coordinatesData : [];
        //(type && type === "MultiPolygon") ? [coordinatesData.reduce((acc, val) => acc.concat(val.reduce((acc2, val2) => acc2.concat(val2), [])), [])] : coordinatesData;
        coordinatesData.forEach(points => {
          const data = points.map(co => { return { lat: co[1], lng: co[0] }; });
          workedLatLng.push(...data);
        });
      }
    }
    return workedLatLng;
  }, [showDropdown, isRequestingHarvestSummary, shapeRefId, harvestSummaryList]);

  useEffect(() => {
    if (showDropdown && !isRequestingWorkInfo) {
      const cb = (dateInfo) => {
        const workTypeIds = selectedWorkTypeIds;
        const hasWorkTypeIds = egWorkDetails.map(item => item.workTypeId);
        const newWorkTypeIds = workTypeIds.filter(id => hasWorkTypeIds.indexOf(id) < 0);

        if (newWorkTypeIds.length > 0) {
          const params = {
            farmId,
            shapeGroupId: fieldListById[shapeRefId].regionDetails.geo_region_uuid,
            shapeRefId,
            workTypeIds: newWorkTypeIds,
            ...dateInfo
          };
          dispatch(getEGWorkedAcres(params));
        }
      };
      dispatch(getDateRangeInfo({ farmId }, cb));
    }
  }, [showDropdown, isRequestingWorkInfo, rangeId, selectedWorkTypeIds, isRequestingPlanPlannedToDate]);

  let isRequestingEgInfo = false;
  let hasEgList = false;
  let hasEgDetails = false;

  for (const item of egWorkDetails) {
    if (item.isRequesting) isRequestingEgInfo = true;
    if (item.payload.length > 0) hasEgList = true;
    if (!hasEgDetails) hasEgDetails = item.payload.filter(item => egListById[item.equipment_group_uuid]).length > 0;
  }

  // const workTypeListById = {};
  // WORK_TYPE_LIST.forEach(item => {
  //   if (item.list) {
  //     item.list.forEach(item => workTypeListById[item.work_type_id] = item.work_type);
  //   } else workTypeListById[item.work_type_id] = item.work_type;
  // });

  const getHarvestValue = (key) => {
    const summary = harvestList && harvestList.summary;
    return summary ? summary[key] || 0 : 0;
  };

  const getSummary = (harvestList, type, fixedValue = 0) => {
    if (!harvestList || !harvestList.summary) return 0;

    const summary = harvestList.summary;
    const workedAcreage = getHarvestValue(summary.harvested_acreage !== undefined ? summary.harvested_acreage : summary.harvest_acreage !== undefined ? summary.harvest_acreage : 0);

    const totalAcreage = getHarvestValue(summary.total_acreage !== undefined ? summary.total_acreage : 0);
    const harvestedLoads = getHarvestValue(summary.harvested_loads !== undefined ? summary.harvested_loads : summary.harvest_loads !== undefined ? summary.harvest_loads : 0);
    switch (type) {
      case "worked":
        return workedAcreage ? unit.toArea(workedAcreage, fixedValue) : 0;

      case "percentage":
        return totalAcreage ? ((unit.toArea(workedAcreage, 0) / unit.toArea(totalAcreage, 0)) * 100).toFixed(0) : 0;

      case "load":
        return harvestedLoads;

      default:
        return 0;
    }
  };

  const getTotalCapacityPerField = (shapeId, weightType, format = true) => {
    const capacity = fieldLoads && fieldLoads.length > 0 && fieldLoads.filter(item => ((item.shapeRefId === shapeId)))
      .reduce((total, item) => total + item[`${weightType}`], 0);
    return format ? formatNumber(unit.toRoundOfWeight(capacity, false)) : capacity;
  };

  const getTareDetails = () => {
    let totalTareWeight = 0;
    let totalRangeTareWeight = 0;
    let totalTareCount = 0;
    let totalNetWeight = 0;
    let toalRangeNetWeight = 0;
    let totalNetWithTare = 0;
    let totalRangeNetWithTare = 0;
    // if (showDropdown) {
    const { tareCapacity, tareCount, rangeTareCapacity } = getRangeTareLoad();
    if (tareCount > 0) {
      totalTareCount = tareCount;
      /* Total tare calculation for todate */
      totalTareWeight = formatNumber(unit.toRoundOfWeight(tareCapacity, false));

      const totalFieldWeigth = getTotalCapacityPerField(shapeRefId, 'loadCapacity', false);
      totalNetWeight = (totalFieldWeigth && totalFieldWeigth > 0) ? (totalFieldWeigth /* - tareCapacity */) : totalFieldWeigth;

      totalNetWithTare = (totalFieldWeigth - tareCapacity);
      totalNetWithTare = formatNumber(unit.toRoundOfWeight(totalNetWithTare, false));

      totalNetWeight = formatNumber(unit.toRoundOfWeight(totalNetWeight, false));

      /* Total tare calculation for calender selected range */
      totalRangeTareWeight = formatNumber(unit.toRoundOfWeight(rangeTareCapacity, false));

      const { rangeLoadCapacity } = getRangeLoads(false);
      toalRangeNetWeight = (rangeLoadCapacity /* - rangeTareCapacity */);

      totalRangeNetWithTare = (rangeLoadCapacity - rangeTareCapacity);
      totalRangeNetWithTare = formatNumber(unit.toRoundOfWeight(totalRangeNetWithTare, false));

      toalRangeNetWeight = formatNumber(unit.toRoundOfWeight(toalRangeNetWeight, false));
    } else {
      totalTareWeight = getTotalCapacityPerField(shapeRefId, 'loadTareWeight');
      totalNetWithTare = getTotalCapacityPerField(shapeRefId, 'loadCapacity');
      totalNetWeight = (getTotalCapacityPerField(shapeRefId, 'loadCapacity', false) + getTotalCapacityPerField(shapeRefId, 'loadTareWeight', false));
      totalNetWeight = formatNumber(unit.toRoundOfWeight(totalNetWeight, false));

      totalRangeTareWeight = getRangeLoads(true).rangeTareLoadCapacity;
      totalRangeNetWithTare = getRangeLoads().rangeLoadCapacity;
      toalRangeNetWeight = (getRangeLoads(false).rangeLoadCapacity + getRangeLoads(false).rangeTareLoadCapacity);
      toalRangeNetWeight = formatNumber(unit.toRoundOfWeight(toalRangeNetWeight, false));
    }
    // }
    return { totalNetWeight, toalRangeNetWeight, totalTareWeight, totalRangeTareWeight, totalTareCount, totalNetWithTare, totalRangeNetWithTare };
  }

  //const isEquals = (getTotalCapacityPerField(shapeRefId, 'loadGrossWeight') > 0) && ((getTotalCapacityPerField(shapeRefId, 'loadCapacity')) > 0) && (getTotalCapacityPerField(shapeRefId, 'loadGrossWeight') === getTotalCapacityPerField(shapeRefId, 'loadCapacity'))
  const { totalNetWeight, toalRangeNetWeight, totalTareWeight, totalRangeTareWeight, totalNetWithTare, totalRangeNetWithTare } = getTareDetails();
  const harvestedLoad = getSummary(harvestList, "load");
  const isFieldHaveLoad = (harvestedLoad && harvestedLoad > 0);

  return <>
    {<Card.Body className={`field-map-body`}>
      {isRequestingEgInfo || isRequestingEg || isRequestingWorkInfo ?
        <div style={{
          position: 'relative',
          left: '50%',
          top: '40%',
        }}>
          Loading...
        </div> :
        <div className='fieldmap_body_content'>
          <Row lg={1} md={1} sm={1} xs={1}>
            {egWorkDetails && egWorkDetails.sort((a, b) => b.workTypeId - a.workTypeId)
              .map((item, index) => {
                const workTypeColor = WORK_TYPE_COLOURS[item.workTypeId];
                if (item.payload.length === 0) return <React.Fragment key={index} />;
                else return <React.Fragment key={index} >
                  <Row className='ml-2'>
                    {item.payload.map((item, i) =>
                      <Col className='col-auto p-0' key={i}>
                        <span className={`badge badge-pill ${item.equipment_group_uuid === selectedEG ? 'badge_selected' : 'EG_badge'} mx-2 mb-2`}>
                          <button style={{ paddingRight: '2px', color: item.equipment_group_uuid === selectedEG ? 'white' : workTypeColor }} onClick={() => setSelectedEG(item.equipment_group_uuid)}>
                            <img className="EG_avatar" src={egListById[item.equipment_group_uuid] && egListById[item.equipment_group_uuid].img &&
                              egListById[item.equipment_group_uuid].img.lg ? egListById[item.equipment_group_uuid].img.lg
                              : 'https://farm-api.prod02.acuitusag.network/images/vehicle/lg/2_9.png'} alt="" style={{ marginLeft: '-8px' }} />
                            <span>{egListById[item.equipment_group_uuid] && egListById[item.equipment_group_uuid].equipment_group_name ?
                              egListById[item.equipment_group_uuid].equipment_group_name : 'Unknown'}</span>
                          </button>
                        </span>
                      </Col>

                    )}
                  </Row>
                </React.Fragment>;
              })
            }
          </Row>
          <Row>
            <Col className={`col-8 p-0 ${hasEgList ? "mt-2" : ""}`}>
              {showDropdown && <RegionMap
                workedPoints={workedPoints}
                width={hasEgList ? '95%' : '95%'}
                mapHeight="100%"
                selectedEG={selectedEG}
                newWorkedPoints={newWorkedPoints}
                fieldListById={fieldListById}
                shapeRefId={shapeRefId}
              />}
            </Col>
            <Col className="harvest_summary dash-field">
              <section className='field-header_container'>
                <h4>Harvest Projection</h4>
                <div className='work-status'>
                  {isCompleted ?
                    <Button variant='danger' size="sm" className="btn-xs mark-completed" onClick={updateStatus}>
                      Mark as Completed
                    </Button>
                    :
                    <Button variant='success' size="sm" className="btn-xs mark-active" onClick={() => updateStatus(isCompleted)}>
                      Mark as Active
                    </Button>
                  }
                </div>
              </section>
              <div className='field-inner_content'>
                <h5>Acres</h5>
                <ul>
                  <li><b>Harvested: </b> {isFieldHaveLoad ? getSummary(harvestList, "worked") : 0} acres</li>
                  <li><b>Total in Field: </b> {unit.toArea(getHarvestValue("total_acreage"), 0)} acres</li>
                  <li><b>Percentage Harvested: </b>  {isFieldHaveLoad ? getSummary(harvestList, "percentage") : 0}%</li>
                </ul>
                <h5>Loads</h5>
                <ul>
                  <li><b>Harvested: </b> {getSummary(harvestList, "load").toFixed(0)} loads</li>
                  <li><b>Projected Total: </b> {getHarvestValue("projected_loads") ? getHarvestValue("projected_loads").toFixed(0) : 0} loads </li>
                  <li><b>Projected Remaining: </b> {getHarvestValue("remaining_loads") ? getHarvestValue("remaining_loads").toFixed(0) : 0} loads</li>
                  {dateRangeType !== 'Todate' && <li><b>Harvested {dateRange}: </b> {getRangeLoads().rangeLoadCount} loads</li>}
                </ul>

                <h5>Weights</h5>
                <ul>
                  <li><b>Total Weight: </b> {totalNetWeight} {weightShortName}</li>
                  <li><b>Total Tare Weight: </b>{totalTareWeight} {weightShortName}</li>
                  <li><b>Total Net Weight: </b> {totalNetWithTare} {weightShortName}</li>
                  {dateRangeType !== 'Todate' ? <li><b>Total Weight {dateRange}: </b> {toalRangeNetWeight} {weightShortName}</li> : <></>}
                  {(dateRangeType !== 'Todate') ? <li><b>Total Tare Weight {dateRange}: </b> {totalRangeTareWeight} {weightShortName}</li> : <></>}
                  {dateRangeType !== 'Todate' ? <li><b>Total Net Weight {dateRange}: </b> {totalRangeNetWithTare} {weightShortName}</li> : <></>}

                </ul>
              </div>

            </Col>
          </Row>
        </div>}
    </Card.Body>}
    {complete && <Modal.Confirm
      isOpen={complete}
      onConfirm={handleFieldWorkStatus}
      iconClassName="fa fa-question"
      title={{ content: "Confirmation" }}
      body={<>Are you sure to mark field <b>{currentFieldName}</b> as {isCompleted ? "completed" : "active"} ?</>}
      variant="info"
      confirmButton={{ variant: "info" }}
      onHide={() => setComplete(false)}
    />}
  </>;
});

export default CardBody;
